export const namespace =
  'canalplus.block.oneshop.unauthenticated_renewal_payment';
export { default as Component } from './components/Payment';
export { default as propsFormatter } from './propsFormatter';
